import { FC, useEffect, useState } from "react"

import { CaseListingProps, CaseListingResponseType } from "./types";
import { CASE_DETAIL_HEADER } from "src/constants/manufacturer";
import ReactPaginate from "react-paginate";

import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import StepperModal from "../stepperModal";
// import { objectToQueryString } from "src/helpers";
import { Link } from "react-router-dom";
import { ManufacturerCaseListingProps } from "src/pages/manufacturer/types";


export type QueryParamsState = {
  sort_by: string;
  direction: "desc" | "asc";
};

const CaseListing: FC<CaseListingProps> = ({ drug, queryParams, updateCaseData }): JSX.Element => {
  const [queryParam, updateQueryParams] = useState<QueryParamsState>({
    direction: "desc",
    sort_by: "",
  });
  const [page, updatePageNumber] = useState<number>(1)
  const [setStepperModalVisibility, updateStepperModalVisibility] = useState<boolean>(false)
  const [selectedCaseId, updateSelectedCaseId] = useState<number>(0)
  const [selectedDrug, updateSelectedDrug] = useState<string>("")

  const { data: manCaseListing, mutate: getCaseListing } =
    useFetch<CaseListingResponseType>(APIEndpoints.GET_MANUFACTURER_CASE_LISTING, { page, ...queryParams })

  useEffect(() => {
    getCaseListing({}, {}, { page: 1, ...queryParams })
    updatePageNumber(1)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParams])

  useEffect(() => {
    if (manCaseListing && manCaseListing.data && manCaseListing.data.length > 0) {
      const totalCasesZil = manCaseListing.data[1]
        .filter((item) => item.drug_name.toLowerCase().includes("zil"))
        .length;
      if (updateCaseData)
        updateCaseData({ drug_cases: totalCasesZil.toString(), total_case: manCaseListing.data[1].length.toString() })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manCaseListing])

  const changePageNumber = (page: { selected: number; }) => {
    console.log(page.selected)
    getCaseListing({}, {}, { page: page.selected + 1, ...queryParams })
    updatePageNumber(page.selected + 1)
  };


  const openModal = (caseId: number, drug_name: string) => {
    updateStepperModalVisibility(true);
    updateSelectedCaseId(caseId);
    updateSelectedDrug(drug_name)
  };
  const changeIdOrder = (tableHeader: string) => {
    const updatedQueryParams: QueryParamsState = {
      sort_by: tableHeader,
      direction: tableHeader === queryParam.sort_by ? (queryParam.direction === "desc" ? "asc" : "desc") : "desc"
    };
    if (manCaseListing as unknown as ManufacturerCaseListingProps[] ) {
      switch (updatedQueryParams.sort_by) {
        case "case_id":
          manCaseListing && manCaseListing.data[1].sort((item1, item2) => {
            if (updatedQueryParams.direction === "asc")
            return Number(item1.case_id) - Number(item2.case_id);
          else
            return Number(item2.case_id) - Number(item1.case_id);
          });
          break;

        case "patient_id":
          manCaseListing && manCaseListing.data[1].sort((item1, item2) => {
            if (updatedQueryParams.direction === "asc")
            return Number(item1.patient_id) - Number(item2.patient_id);
          else
            return Number(item2.patient_id) - Number(item1.patient_id);
        });
          break;
        case "drug_name":
          manCaseListing && manCaseListing.data[1].sort((item1, item2) => {
            if (updatedQueryParams.direction === "asc")
              return (item1.drug_name || "").localeCompare(item2.drug_name || "");
            else
              return (item2.drug_name || "").localeCompare(item1.drug_name || "");
          });
          break;
        case "qty":
          manCaseListing && manCaseListing.data[1].sort((item1, item2) => {
            if (updatedQueryParams.direction === "asc")
              return (item1.qty || "").localeCompare(item2.qty || "");
            else
              return (item2.qty || "").localeCompare(item1.qty || "");
          });
          break;
        case "received":
          manCaseListing && manCaseListing.data[1].sort((item1, item2) => {
            if (updatedQueryParams.direction === "asc")
              return (item1.received || "").localeCompare(item2.received || "");
            else
              return (item2.received || "").localeCompare(item1.received || "");
          });
          break;
        case "completed":
          manCaseListing && manCaseListing.data[1].sort((item1, item2) => {
            if (updatedQueryParams.direction === "asc")
              return (item1.completed || "").localeCompare(item2.completed || "");
            else
              return (item2.completed || "").localeCompare(item1.completed || "");
          });
          break;
        case "payer":
          manCaseListing && manCaseListing.data[1].sort((item1, item2) => {
            if (updatedQueryParams.direction === "asc")
              return (item1.payer || "").localeCompare(item2.payer || "");
            else
              return (item2.payer || "").localeCompare(item1.payer || "");
          });
          break;
        case "rx_cvge":
          manCaseListing && manCaseListing.data[1].sort((item1, item2) => {
            if (updatedQueryParams.direction === "asc")
              return (item1.rx_cvge || "").localeCompare(item2.rx_cvge || "");
            else
              return (item2.rx_cvge || "").localeCompare(item1.rx_cvge || "");
          });
          break;
        case "med_cvge":
          manCaseListing && manCaseListing.data[1].sort((item1, item2) => {
            if (updatedQueryParams.direction === "asc")
              return (item1.med_cvge || "").localeCompare(item2.med_cvge || "");
            else
              return (item2.med_cvge || "").localeCompare(item1.med_cvge || "");
          });
          break;


        case "rx_pa.data":
          manCaseListing && manCaseListing.data[1].sort((item1, item2) => {
            if (updatedQueryParams.direction === "asc")
              return Number(item1.rx_pa.data) - Number(item2.rx_pa.data);
            else
              return Number(item2.rx_pa.data) - Number(item1.rx_pa.data);
            // return Number(item2.bi_ct) - Number(item1.bi_ct);
          });
          break;

        case "med_pa.data":
          manCaseListing && manCaseListing.data[1].sort((item1, item2) => {
            if (updatedQueryParams.direction === "asc")
              return Number(item1.med_pa.data || 0) - Number(item2.med_pa.data || 0);
            else
              return Number(item2.med_pa.data || 0) - Number(item1.med_pa.data || 0);
          });
          break;

        case "case_status":
          manCaseListing && manCaseListing.data[1].sort((item1, item2) => {
            if (updatedQueryParams.direction === "asc")
              return (item1.case_status || "").localeCompare(item2.case_status || "");
            else
              return (item2.case_status || "").localeCompare(item1.case_status || "");
          });
          break;
        case "provider.doc_name":
          manCaseListing && manCaseListing.data[1].sort((item1, item2) => {
            if (updatedQueryParams.direction === "asc")
              return item1.provider.doc_name.localeCompare(item2.provider.doc_name);
            else
              return item2.provider.doc_name.localeCompare(item1.provider.doc_name);
          });
          break;
      }
    }


      updateQueryParams(updatedQueryParams);
      console.log("queryParam....",queryParams,"  ",updatedQueryParams)
     //getCaseListing({}, {}, { page: 1, ...updatedQueryParams })
  };

  return (
    <div className="col-12">
      <div className="card">
        <div className={`card-header ${drug.includes('roduct') ? '' : (drug.includes('iovera') ? 'iovera-theme' : 'zilretta-theme')}`}>
          <h4 className="m-0">Case Details</h4>
        </div>
        <div className="card-body">
          <div
            className="table-responsive-sm table-responsive-md table-responsive-lg flex-fill overflow-auto"
            style={{ maxHeight: 500 }}
          >
            <table className="table table-striped table-sm m-0">
              <thead>
                <tr className="text-center">
                  {CASE_DETAIL_HEADER.map((tableHeader, index) => (
                    <th key={index}
                      onClick={tableHeader.value !== '' ? () => changeIdOrder(tableHeader.value) : undefined}
                    >
                      <span role={tableHeader.value === '' ? "textbox" : "button"}
                      className={
                          tableHeader.value === '' ?
                            'fw-bold fs-6 lh-base' :
                            'btn btn-link link-primary link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover p-0 fw-bold'
                        }
                      >{tableHeader.label}
                        {(queryParam as any).sort_by === tableHeader.value ? (
                          <i className={`bi ${(queryParam as any).direction === 'desc' ? 'bi-caret-down-fill' : 'bi-caret-up-fill'}`}></i>
                        ) : null}
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {manCaseListing && manCaseListing.data.length > 0 ?
                  manCaseListing.data[1].map(item => (
                    <tr className="align-middle text-center ">
                      <td>
                        <a href="javascript:void(0)"
                          onClick={() => item.case_id ? openModal(item.case_id, item.drug_name) : null}
                        >{item?.case_id}</a>
                      </td>
                      <td>
                        {/* <Link to={{ pathname: '/statistics', search: objectToQueryString(searchPatientID) }}  target="_blank" className="fw-normal fs-6 btn  btn-link btn-link link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover" onClick={() => onPatientIdPress(item?.patient_id)}>{item?.patient_id} </Link> </td> */}
                        {item?.patient_id}</td>
                      <td>{item.drug_name}</td>
                      <td>{item.qty}</td>
                      <td>{item.received}</td>
                      <td className='align-middle'>
                        {item.completed}
                      </td>
                      <td>{item.payer}</td>
                      <td className="align-middle">{item.rx_cvge}</td>
                      <td>{item.med_cvge || ''}</td>
                      <td>{item.rx_pa ? item.rx_pa.data : ''}</td>
                      <td>{item.med_pa ? item.med_pa.data : ''}</td>
                      <td className="align-middle">
                        <span className={`badge background-color-${item && item.color_idx ? item.color_idx : 1}`}>
                          {item ? item.case_status : ''}
                        </span>
                      </td>
                      {/* <td>
                                          {item.provider ? item.provider.doc_name : ''}
                                      </td> */}
                      <td className="text-center">
                        <Link
                          to={{
                            pathname: '/territories',
                            search: (() => {
                              const newParams = new URLSearchParams()
                              newParams.set("userId",item.provider.doctor_id.toString() || "");
                              newParams.set("doc_name", item?.provider.doc_name)
                              newParams.set("role","doctor");
                              newParams.set("drug", drug || "")
                              newParams.set("type", "doc_stats")
                              const totalCasesZil = manCaseListing.data[1]
                                .filter((item) => item.drug_name.toLowerCase().includes("zil"))
                                .length;
                              newParams.set("zil_count", totalCasesZil.toString())
                              newParams.set("total_cases", manCaseListing.data[1].length.toString())
                              return newParams.toString();
                            })(),
                          }}
                          reloadDocument
                          data-bs-toggle="tooltip"
                          data-bs-placement="right"
                          className="link-underline link-underline-opacity-0 link-offset-0-hover link-underline-opacity-75-hover"
                          title={item && item.provider ?
                            `${(item.provider.practice_name ? `Practice: ${item.provider.practice_name}` : '')}
                             ${(item.provider.address ? `\nAddress: ${item.provider.address}` : '')}
                             ${(item.provider.phone ? `\nPhone: ${item.provider.phone}` : '')}
                             ${(item.provider.fax ? `\nFax: ${item.provider.fax}` : '')}` : ''}
                        >
                          {item?.provider.doc_name}
                        </Link>
                      </td>
                    </tr>
                  ))
                  : null}
              </tbody>
            </table>
          </div>

          {manCaseListing && manCaseListing.data.length > 0 && manCaseListing.data[0] > 1 ? (
            <ul className="pagination-nav pagination-sm pagination-lg justify-content-center flex-wrap gap-2 mb-0 mt-3">
              <ReactPaginate
                nextLabel={<>Next <i className="bi bi-chevron-right"></i></>}
                onPageChange={changePageNumber}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={manCaseListing && manCaseListing.data.length > 0 ? manCaseListing.data[0] : 1}
                previousLabel={<><i className="bi bi-chevron-left"></i> Previous</>}
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination pagination-sm pagination-lg mb-0"
                activeClassName="active"
                renderOnZeroPageCount={null}
                forcePage={page - 1}
              />
            </ul>
          ) : null}
        </div>

        {setStepperModalVisibility ? (
          <StepperModal
            onClick={() => {
              updateStepperModalVisibility(false);
              updateSelectedCaseId(0);
              updateSelectedDrug("")
            }}
            caseId={selectedCaseId}
            drugName={selectedDrug}
          />
        ) : null}
      </div>
    </div>
  );
};

export default CaseListing;
